import Newsletter from ".";

export const newsletterRoutes = () => [
  {
    path: "/admin/newsletter",
    title: "Newsletter",
    code: "newsletter",
    layout: "admin",
    routeType: "admin",
    component: Newsletter,
  },
];